import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const headerBg = useColorModeValue('gray.50', 'whiteAlpha.50');
  const hoverBg = useColorModeValue('gray.50', 'whiteAlpha.50');
  const textColor = useColorModeValue('gray.700', 'white');
  const mutedTextColor = useColorModeValue('gray.500', 'gray.300');
  const cardBg = useColorModeValue('white', 'navy.800');
  const inputColor = useColorModeValue('gray.800', 'whiteAlpha.900');
  const placeholderColor = useColorModeValue('gray.500', 'gray.400');

  /** Listing-style panels (SupplierInfoCard / tooltips) */
  const tooltipBg = useColorModeValue('white', 'gray.700');
  const tooltipBorder = useColorModeValue('gray.200', 'whiteAlpha.200');
  const tooltipHeading = useColorModeValue('navy.700', 'white');
  const tooltipCodeBg = useColorModeValue('gray.50', 'whiteAlpha.100');
  const tooltipShadow = useColorModeValue(
    '0 4px 14px rgba(0,0,0,0.08)',
    '0 8px 24px rgba(0,0,0,0.35)',
  );

  return {
    borderColor,
    headerBg,
    hoverBg,
    textColor,
    mutedTextColor,
    cardBg,
    inputColor,
    placeholderColor,
    tooltipBg,
    tooltipBorder,
    tooltipHeading,
    tooltipCodeBg,
    tooltipShadow,
  };
};
